import type { ReactNode } from 'react';

import { NoData } from '@/components/legacy-ui/NoData';
import { Loader } from '@/components/Loader';

interface PaneStateProps {
  isLoading: boolean;
  isEmpty: boolean;
  empty: { title: string; description: string };
  children: ReactNode;
}

/**
 * Three-state wrapper used by every hunt detail pane.
 * Centralizes the loading spinner and the `NoData` empty state so
 * each pane only owns its "loaded with content" branch.
 */
export function PaneState({
  isLoading,
  isEmpty,
  empty,
  children,
}: PaneStateProps) {
  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Loader isLoading type="spinner" />
      </div>
    );
  }
  if (isEmpty) {
    return (
      <NoData
        styleType="text"
        title={empty.title}
        description={empty.description}
      />
    );
  }
  return <>{children}</>;
}
